import { Injectable, OnDestroy } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import * as _ from "lodash";
import { AuthenticationService } from "../auth/authentication.service";
import { AddConversationComponent } from "../dashboard/tickets/add-conversation/add-conversation.component";
import { ResetPasswordComponent } from "../dashboard/setup/users/reset-password/reset-password.component";
import { CompletionFormComponent } from "../dashboard/job-orders/completion-form/completion-form.component";
import { VerificationRequisitionComponent } from "../dashboard/inventory/requisition/verification-requisition/verification-requisition.component";
import { AddEditTaskComponent } from "../dashboard/tasks/add-edit-task/add-edit-task.component";
import { SmartAssignComponent } from "../dashboard/tasks/smart-assign/smart-assign.component";
import { ViewMapPinComponent } from "../shared/comman-component/view-map-pin/view-map-pin.component";
import { DownloadBarcodeComponent } from "../shared/comman-component/download-barcode/download-barcode.component";
import { AddEditSlaCriteriaComponent } from "../dashboard/setup/sla/sla-step/add-edit-sla-criteria/add-edit-sla-criteria.component";
import { AddEditHPFormComponent } from "../dashboard/job-orders/add-edit-hpform/add-edit-hpform.component";
import { ImportDataComponent } from "../dashboard/setup/import-export/import-data/import-data.component";
import { ExportDataComponent } from "../dashboard/setup/import-export/export-data/export-data.component";
import { ImportUploadFilesComponent } from "../dashboard/setup/import-export/import-upload-files/import-upload-files.component";
import { ImportDataListComponent } from "../dashboard/setup/import-export/import-data-list/import-data-list.component";
import { DownloadExportDataComponent } from "../dashboard/setup/import-export/download-export-data/download-export-data.component";
import { TicketFormatComponent } from "../dashboard/setup/tickets/ticket-format/ticket-format.component";
import { CheckAvailabilityComponent } from "../dashboard/tasks/check-availability/check-availability.component";
import { TaskCloneComponent } from "../dashboard/tasks/task-clone/task-clone.component";
import { SlaConditionComponent } from "../dashboard/setup/sla/sla-package/sla-condition/sla-condition.component";
import { UploadPhotoComponent } from "../dashboard/setup/users/upload-photo/upload-photo.component";
import { CloneAccessComponent } from "../dashboard/setup/access/clone-access/clone-access.component";
import { InfoGuideComponent } from "../shared/comman-component/info-guide/info-guide.component";
import { MagnumDashboardTableComponent } from "../dashboard/home/magnum/magnum-dashboard-table/magnum-dashboard-table.component";
import { AcceptDeclineTaskComponent } from "../dashboard/tasks/accept-decline-task/accept-decline-task.component";
import { AddMemberComponent } from "../dashboard/tasks/add-member/add-member.component";
import { OptimizeDistanceComponent } from "../dashboard/tasks/optimize-distance/optimize-distance.component";
import { AddEditNotesComponent } from "../dashboard/tasks/view-tasks/add-edit-notes/add-edit-notes.component";
import { RequestAssistanceComponent } from "../dashboard/tasks/request-assistance/request-assistance.component";
import { SalesOrderFormatComponent } from "../dashboard/setup/sales-order/sales-order-format/sales-order-format.component";
import { JobOrderFormatComponent } from "../dashboard/setup/job-orders/job-order-format/job-order-format.component";
import { ProjectFormatComponent } from "../dashboard/setup/projects/project-format/project-format.component";
import { SiteFormatComponent } from "../dashboard/setup/sites/site-format/site-format.component";
import { TaskJourneyComponent } from "../dashboard/tasks/task-journey/task-journey.component";
import { JoTimeJourneyComponent } from "../dashboard/job-orders/jo-time-journey/jo-time-journey.component";
import { HazardControlComponent } from "../dashboard/tasks/hazard-control/hazard-control.component";
import { ExactAssignComponent } from "../dashboard/tasks/exact-assign/exact-assign.component";
import { ChecklistProductComponent } from "../shared/comman-component/checklist-product/checklist-product.component";
import { UpdateStatusComponent } from "../dashboard/shared/update-status/update-status.component";
import { AddJoTaskTemplateComponent } from "../dashboard/setup/job-orders/jo-templates/jo-task-template/add-jo-task-template/add-jo-task-template.component";
import { CustomerFormatComponent } from "../dashboard/setup/customer/customer-format/customer-format.component";
import { AssetFormatComponent } from "../dashboard/setup/assets/asset-format/asset-format.component";
import { CalendlyLinkComponent } from "../dashboard/job-orders/calendly-link/calendly-link.component";
import { SetUpEventsComponent } from "../dashboard/setup/integrations/set-up-events/set-up-events.component";
import { UpdateThemeComponent } from "../dashboard/setup/integrations/update-theme/update-theme.component";
import { DisconnectConfmationComponent } from "../public/google-calendar/disconnect-confmation/disconnect-confmation.component";
import { SalesforceIntegrationComponent } from "../dashboard/setup/integrations/salesforce-integration/salesforce-integration.component";
import { SurveyLinkComponent } from "../dashboard/job-orders/survey-link/survey-link.component";
import { ViewSurveyFormComponent } from "../dashboard/job-orders/view-survey-form/view-survey-form.component";
import { ResetContactPasswordComponent } from "../dashboard/shared/reset-contact-password/reset-contact-password.component";
import { AddEditTeamMembersComponent } from "../dashboard/teams/view-team-schedules/team-members/add-edit-team-members/add-edit-team-members.component";
import { AddImageEmailComponent } from "../dashboard/setup/emails/add-image-email/add-image-email.component";
import { PreviewEmailComponent } from "../dashboard/setup/notifications/preview-email/preview-email.component";
import { AddExistingNotificationComponent } from "../dashboard/setup/workflows/add-existing-notification/add-existing-notification.component";
import { CancelContractComponent } from "../dashboard/contracts/cancel-contract/cancel-contract.component";
import { SubscriptionUtil } from "../_utilities/subscription";
import { LanguageTranslateService } from "./language-translate.service";
import { HowToConditionComponent } from "../dashboard/setup/workflows/how-to-condition/how-to-condition.component";
import { HowToEmailComponent } from "../dashboard/setup/emails/how-to-email/how-to-email.component";
import { SmartSuggestionsComponent } from "../shared/comman-component/smart-suggestions/smart-suggestions.component";
import { CommonProductComponent } from "../shared/comman-component/common-product/common-product.component";
import { AddViaSerialNumberSkuComponent } from "../dashboard/inventory/bin-transfer/add-via-serial-number-sku/add-via-serial-number-sku.component";
import { UpdateChildAssetComponent } from "../dashboard/asset/update-child-asset/update-child-asset.component";
import { ApprovalConfigurationComponent } from "../dashboard/setup/approval/approval-configuration/approval-configuration.component";
import { EditRequisitionNotesComponent } from "../dashboard/inventory/global-requisition/edit-requisition-notes/edit-requisition-notes.component";
import { GlobalRequestSummaryComponent } from "../dashboard/inventory/global-requisition/global-request-summary/global-request-summary.component";
import { HowItWorksComponent } from "../dashboard/setup/approval/how-it-works/how-it-works.component";
import { AddEditUserBinsComponent } from "../dashboard/setup/inventory-setup/user-bins/add-edit-user-bins/add-edit-user-bins.component";
import { BulkExportQrComponent } from "../dashboard/asset/bulk-export-qr/bulk-export-qr.component";
import { UpgradeToPlanComponent } from "../shared/comman-component/upgrade-to-plan/upgrade-to-plan.component";
import { CreateAssetJoComponent } from "../shared/comman-component/create-asset-jo/create-asset-jo.component";
import { RequestOrgDeleteComponent } from "../shared/comman-component/request-org-delete/request-org-delete.component";
import { LearnMoreModalComponent } from "../shared/comman-component/learn-more-modal/learn-more-modal.component";
import { ImportAssetsComponent } from "../shared/comman-component/import-assets/import-assets.component";
import { AddEditFolderTreeComponent } from "../dashboard/reports/folder-tree/add-edit-folder-tree/add-edit-folder-tree.component";
import { AddEditReportComponent } from '../dashboard/reports/report-pages/add-edit-report/add-edit-report.component'; import { ReportShareComponent } from "../dashboard/reports/report-share/report-share.component";
import { ReportExportComponent } from "../dashboard/reports/report-export/report-export.component";
import { ReportDuplicateComponent } from "../dashboard/reports/report-duplicate/report-duplicate.component";
import { ReportMoveComponent } from "../dashboard/reports/report-move/report-move.component";
import { ReportDeleteComponent } from "../dashboard/reports/report-delete/report-delete.component";

import { AddEditComponentComponent } from "../dashboard/asset/asset-component/add-edit-component/add-edit-component.component";
import { OwnershipConfirmationPopupComponent } from "../dashboard/reports/folder-tree/ownership-confirmation-popup/ownership-confirmation-popup.component";
import { ReportScheduleExportComponent } from "../dashboard/reports/report-schedule-export/report-schedule-export.component";

import { PreviewSelectedPlanComponent } from "../dashboard/preventive-maintenance-standalone/view-plan/add-asset-to-plan/preview-selected-plan/preview-selected-plan.component";
import { AssignToComponent } from '../dashboard/preventive-maintenance-standalone/add-edit-plan/assign-to/assign-to.component';
import { ClonePlanComponent } from "../dashboard/preventive-maintenance-standalone/view-plan/clone-plan/clone-plan.component";
import { AdjustDatePlanComponent } from "../dashboard/preventive-maintenance-standalone/view-plan/adjust-date-plan/adjust-date-plan.component";
import { UpdateAssigneeComponent } from "../dashboard/setup/job-orders/jo-templates/update-assignee/update-assignee.component";
import { AddProcedureComponent } from "../dashboard/setup/job-orders/jo-templates/add-procedure/add-procedure.component";
import { UpdateLocationComponent } from "../dashboard/job-orders/update-location/update-location.component";
import { UpdateContactComponent } from "../dashboard/job-orders/update-contact/update-contact.component";
import { ChooseJobTypeComponent } from "../dashboard/job-orders/choose-job-type/choose-job-type.component";
import { ChooseJobTemplateComponent } from "../dashboard/job-orders/choose-job-template/choose-job-template.component";
import { CloneTypeComponent } from "../dashboard/setup/job-orders/job-order-type-standalone/clone-type/clone-type.component";
import { AddStatusComponent } from "../dashboard/setup/job-orders/job-order-type-standalone/add-edit-type-standalone/statuses/add-status/add-status.component";
import { ReorderTypesComponent } from "../dashboard/setup/job-orders/job-order-type-standalone/reorder-types/reorder-types.component";
import { AddEditTaskLiteComponent } from "../dashboard/tasks/add-edit-task-lite/add-edit-task-lite.component";
import { UtilizeFromBinComponent } from "../dashboard/job-orders/jo-spare-part-standalone/utilize-from-bin/utilize-from-bin.component";
import { AssignJoOwnerComponent } from "../dashboard/job-orders/job-order-details-v2/assign-jo-owner/assign-jo-owner.component";
import { JoStandaloneEmailPdfComponent } from "../shared/comman-component/jo-standalone-email-pdf/jo-standalone-email-pdf.component";
import { LiveFormPreviewComponent } from "../dashboard/setup/job-orders/job-order-type-standalone/add-edit-type-standalone/live-form-preview/live-form-preview.component";
import { ReportMultipleScheduleComponent } from "../dashboard/reports/report-multiple-schedule/report-multiple-schedule.component";
import { OauthCredentialsComponent } from "../dashboard/setup/integrations/oauth/oauth-credentials/oauth-credentials.component";
import { ProductBulkExportQrComponent } from "../dashboard/product/product-bulk-export-qr/product-bulk-export-qr.component";
import { MappedFieldsComponent } from "../dashboard/setup/app-connector/connector-settings/sync/mapped-fields/mapped-fields.component";
import { XeroMappedFieldsComponent } from "../dashboard/setup/integrations/xero/sync/xero-mapped-fields/xero-mapped-fields.component";
import { FilterOptionsComponent } from "../dashboard/schedular/schedular-table/filter-options/filter-options.component";
import { GroupByOptionsComponent } from "../dashboard/schedular/schedular-table/group-by-options/group-by-options.component";
import { ReScheduleComponent } from "../dashboard/schedular/re-schedule/re-schedule.component";
import { PrintJobSheetComponent } from "../dashboard/schedular/print-job-sheet/print-job-sheet.component";
import { OwnerAssignComponent } from "../dashboard/schedular/owner-assign/owner-assign.component";
import { ActivatePortalComponent } from "../dashboard/setup/customer-portal-config/activate-portal/activate-portal.component";
import { AvailableStatusesComponent } from "../dashboard/setup/customer-portal-config/available-statuses/available-statuses.component";
import { SendEmailPdfComponent } from "../dashboard/schedular/send-email-pdf/send-email-pdf.component";
import { TemplateFormatComponent } from "../dashboard/setup/job-orders/jo-pdf-template/template-format/template-format.component";
import { DocumentsCtaComponent } from "../dashboard/job-orders/job-order-documents/documents-cta/documents-cta.component";
import { NewRecipientComponent } from "../dashboard/job-orders/job-order-documents/documents-cta/new-recipient/new-recipient.component";
import { PdfViewerComponent } from "../shared/comman-component/pdf-viewer/pdf-viewer.component";
import { TransferPdfComponent } from "../dashboard/inventory/bin-transfer/view-bin-transfer/transfer-pdf/transfer-pdf.component";
import { MissingConfigurationComponent } from "../shared/comman-component/missing-configuration/missing-configuration.component";
import { LinkAssetToCustomerSiteProjectComponent } from "../shared/link-asset-to-customer-site-project/link-asset-to-customer-site-project.component";
import { AddAssetStatusComponent } from "../dashboard/setup/assets/asset-type-standalone/add-edit-asset-type/asset-statuses/add-asset-status/add-asset-status.component";
import { PlanTypeOptionsComponent } from "../dashboard/preventive-maintenance-standalone/plan-type-options/plan-type-options.component";
import { ConfigureCertificateComponent } from "../dashboard/setup/assets/asset-type-standalone/add-edit-asset-type/certificate-settings/configure-certificate/configure-certificate.component";
import { ConfigureInspectionComponent } from "../dashboard/setup/assets/asset-type-standalone/add-edit-asset-type/inspection-settings/configure-inspection/configure-inspection.component";
import { MarkCompleteCertComponent } from "../shared/comman-component/mark-complete-cert/mark-complete-cert.component";
import { MaintenanceJobListComponent } from "../dashboard/cmms-dashboard/maintenance-cmms/maintenance-job-list/maintenance-job-list.component";
import { ComplianceCertInspecListComponent } from "../dashboard/cmms-dashboard/compliance-cmms/compliance-cert-inspec-list/compliance-cert-inspec-list.component";
import { AssetOpenJobComponent } from "../dashboard/cmms-dashboard/asset-cmms/asset-open-job/asset-open-job.component";
import { SettingsColorCodeComponent } from "../dashboard/schedular/schedular-table/settings-color-code/settings-color-code.component";
import { UpdateComponentConfirmComponent } from "../dashboard/asset/update-component-confirm/update-component-confirm.component";
import { UserManageSkillsComponent } from "../dashboard/setup/users/user-details-v2/user-manage-skills/user-manage-skills.component";
import { ManageWorkingHoursComponent } from "../dashboard/setup/users/user-details-v2/manage-working-hours/manage-working-hours.component";
import { ManageSetupAccessComponent } from "../dashboard/setup/users/user-details-v2/manage-setup-access/manage-setup-access.component";
import { CreateBlockAreaLvlComponent } from "../dashboard/sites/site-blocks/create-block-area-lvl/create-block-area-lvl.component";
import { CreateBlockTaskComponent } from "../dashboard/sites/site-blocks/create-block-task/create-block-task.component";
import { CreateContractInBlockComponent } from "../dashboard/sites/site-blocks/create-contract-in-block/create-contract-in-block.component";
import { SelectExistingContractInBlockComponent } from "../dashboard/sites/site-blocks/select-existing-contract-in-block/select-existing-contract-in-block.component";
import { GenerateJobPlannerComponent } from "../dashboard/planner/generate-job-planner/generate-job-planner.component";
import { ManageUserGroupComponent } from "../dashboard/setup/users/user-details-v2/manage-user-group/manage-user-group.component";
import { ManageIntegrationsComponent } from "../dashboard/setup/users/user-details-v2/manage-integrations/manage-integrations.component";
import { AutoAssignMonthComponent } from "../dashboard/planner/auto-assign-month/auto-assign-month.component";
import { AssignShiftsComponent } from "../dashboard/setup/shifts/assign-shifts/assign-shifts.component";
import { ImportBulkShiftsComponent } from "../dashboard/setup/shifts/import-bulk-shifts/import-bulk-shifts.component";
import { ClearMonthComponent } from "../dashboard/planner/clear-month/clear-month.component";
import { BulkReassignUserComponent } from "../dashboard/planner/bulk-reassign-user/bulk-reassign-user.component";

import { SuggestedUsersPreviewComponent } from '../dashboard/setup/job-orders/job-order-type-standalone/add-edit-type-standalone/type-settings/suggested-users-preview/suggested-users-preview.component';
import { PreviewSuggestedUsersComponent } from "../shared/comman-component/preview-suggested-users/preview-suggested-users.component";
import { CreateMilestonesComponent } from "../dashboard/project/project-milestones/create-milestones/create-milestones.component";
@Injectable()
export class ModalServiceService extends SubscriptionUtil implements OnDestroy {
  selectedComponent: any;
  selectedConfig: any;
  modalState: any;
  modalRef!: BsModalRef;
  addonFeature: any;
  configMd: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-md",
    container: "app-root",
  };
  configMdCenter: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-md modal-dialog-centered",
    container: "app-root",
  };
  configMdSkimCenter: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-md modal-dialog-centered modal-dialog-800",
    container: "app-root",
  };
  configMdSkimV2Center: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-md modal-dialog-centered modal-dialog-818",
    container: "app-root",
  };
  configSM: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-sm",
    container: "app-root",
  };
  configSMLong: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-sm sm-long",
    container: "app-root",
  };
  configCustomLgNonScroll: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "custom-modal-lg",
    container: "app-root",
  };
  configSMCenter: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-sm modal-dialog-centered",
    container: "app-root",
  };
  configSMSkimCenter: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-sm sm-skim modal-dialog-centered",
    container: "app-root",
  };
  configSMLongCenter: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-sm sm-long modal-dialog-centered",
    container: "app-root",
  };
  configCustomLg: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "custom-modal-lg modal-dialog-scrollable",
    container: "app-root",
  };
  configCustomLgCenter: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "custom-modal-lg modal-dialog-scrollable modal-dialog-centered",
    container: "app-root",
  };
  configCenterOnly: any = {
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
    class: "modal-dialog-centered",
    container: "app-root",
  };

  configCustomXl: any = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: true,
    class: "custom-modal-xl",
    container: "app-root",
  };

  private allModalRefs: BsModalRef[] = [];
  translate: any;

  constructor(
    public modalService: BsModalService,
    private auth: AuthenticationService,
    private languageTranslateService: LanguageTranslateService
  ) {
    super();
    this.init();
  }

  private init() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      })
    );

    if (this.modalRef) {
      this.modalRef.onHide?.subscribe((eve) => {
        console.log('onHide modalRef subscription in modal-service')
        this.allModalRefs.forEach((mf) => {
          mf.hide();
        });
      });
    }
  }

  ngOnDestroy(): void {
    // Complete any observables that need manual cleanup
    console.log("destroyed");
    super.ngOnDestroy();
  }

  openModal(modalView: any, data2: any, config?: any) {
    if (config) {
      this.configMd = Object.assign(this.configMd, config);
    }

    this.addonFeature = this.auth.addonFeature();
    var data = _.cloneDeep(data2);
    //console.log(data)
    this.selectedConfig = this.configMd;
    if (modalView === "resetPassword") {
      this.modalState = {
        title: this.translate.resetPassword.label.singular,
        data: data.login,
        type: "self",
      };
      this.selectedConfig = this.configSM;
      // this.selectedComponent = DeletePaymentComponent;
      this.selectedComponent = ResetPasswordComponent;
    } else if (modalView === "resetContactPassword") {
      this.modalState = {
        title: this.translate.resetPassword.label.singular,
        data: data.login,
        data1: data,
        type: "self",
      };
      this.selectedConfig = this.configSMCenter;
      // this.selectedComponent = DeletePaymentComponent;
      this.selectedComponent = ResetContactPasswordComponent;
    } else if (modalView == "addComment") {
      this.modalState = {
        title: this.translate.ticket.sections.sec7.singular,
        mode: "add",
        data: data,
      };
      this.selectedComponent = AddConversationComponent;
    } else if (modalView === "completionForm") {
      this.modalState = {
        title: this.translate.jobOrder.fields.completionForm.singular,
        data: data,
      };

      this.selectedComponent = CompletionFormComponent;
    } else if (modalView === "addEditTask") {
      this.modalState = {
        title: this.translate.task.sections.sec28.singular,
        data: data,
        mode: data.mode,
      };

      this.selectedComponent = AddEditTaskComponent;
    } else if (modalView === "addEditTaskLite") {
      this.modalState = {
        title: this.translate.task.sections.sec28.singular,
        data: data,
        mode: data.mode,
      };

      this.selectedComponent = AddEditTaskLiteComponent;
    } else if (modalView === "addEditTeamMembers") {
      this.modalState = {
        title: this.translate.setup.users.teams.sections.sec7.singular,
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AddEditTeamMembersComponent;
    } else if (modalView === "editTeamMembers") {
      this.modalState = {
        title: this.translate.setup.users.teams.sections.sec9.singular,
        data: data,
        mode: "edit",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AddEditTeamMembersComponent;
    } else if (modalView === "smart-assign") {
      this.modalState = {
        title: "smart-assign",
        data: data,
        mode: "add",
      };

      this.selectedComponent = SmartAssignComponent;
    } else if (modalView === "confirmContactResetPassword") {
      this.modalState = {
        title: this.translate.resetPassword.label.singular,
        data: data.login,
        data1: data,
        type: "others",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = ResetContactPasswordComponent;
    } else if (modalView === "confirmResetPassword") {
      this.modalState = {
        title: this.translate.resetPassword.label.singular,
        data: data.login,
        data1: data,
        type: "others",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = ResetPasswordComponent;
    } else if (modalView === "resendActivationEmail") {
      this.modalState = {
        title: this.translate.setup.users.users.sections.sec22.singular,
        data: data.id,
        type: "resendCustomerUserEmail",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = ResetPasswordComponent;
    } else if (modalView === "resendActivationEmailUser") {
      this.modalState = {
        title: this.translate.setup.users.users.sections.sec22.singular,
        data: data.id,
        data1: data,
        type: "resendEmail",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = ResetPasswordComponent;
    } else if (modalView == "verificationRequisition") {
      this.modalState = {
        title: this.translate.requisition.sections.sec9.singular,
        mode: "edit",
        data: data,
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = VerificationRequisitionComponent;
    } else if (modalView == "viewMapPin") {
      this.modalState = {
        title: this.translate.general.locationDetails.sections.sec7.singular,
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ViewMapPinComponent;
    } else if (modalView == "barcode") {
      this.modalState = {
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = DownloadBarcodeComponent;
    } else if (modalView == "addEditCriteria") {
      this.modalState = {
        title: this.translate.setup.sla.steps.sections.sec14.singular,
        mode: "create",
        data: data,
      };
      // this.selectedConfig = this.configCustomLg;
      this.selectedComponent = AddEditSlaCriteriaComponent;
    } else if (modalView == "addProduct") {
      this.modalState = {
        title: this.translate.checklist.sections.sec13.singular,
        mode: "create",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ChecklistProductComponent;
    } else if (modalView == "updateStatus") {
      this.modalState = {
        title: this.translate.general.status.messages.updateStatus,
        mode: "create",
        data: data,
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = UpdateStatusComponent;
    } else if (modalView == "createCondition") {
      this.modalState = {
        title: this.translate.setup.sla.packages.sections.sec9.singular,
        mode: "create",
        data: data,
      };
      // this.selectedConfig = this.configCustomLg;
      this.selectedComponent = SlaConditionComponent;
    } else if (modalView == "optimizeDistance") {
      this.modalState = {
        title: this.translate.task.sections.sec29.singular,
        mode: "create",
        data: data,
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = OptimizeDistanceComponent;
    } else if (modalView == "editNotes") {
      this.modalState = {
        title: this.translate.general.buttons.editNotes.singular,
        mode: "edit",
        data: data,
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = AddEditNotesComponent;
    } else if (modalView === "addEditHpForm") {
      this.modalState = {
        title: this.translate.jobOrder.sections.sec44.singular,
        mode: "edit",
        data: data,
      };
      this.selectedComponent = AddEditHPFormComponent;
    } else if (modalView === "cancelContract") {
      this.modalState = {
        title: this.translate.contracts.sections.sec10.singular,
        data: data,
      };
      this.selectedComponent = CancelContractComponent;
    } else if (modalView == "import") {
      this.modalState = {
        title: this.translate.setup.importExport.sections.sec2.singular,
        mode: "edit",
        data: data,
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = ImportDataComponent;
    } else if (modalView == "importUpload") {
      this.modalState = {
        title: this.translate.setup.importExport.sections.sec2.singular,
        mode: "edit",
        data: data,
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = ImportUploadFilesComponent;
    } else if (modalView == "listImports") {
      this.modalState = {
        title: this.translate.setup.importExport.sections.sec2.singular,
        mode: "edit",
        data: data,
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = ImportDataListComponent;
    } else if (modalView == "export") {
      this.modalState = {
        title: this.translate.setup.importExport.sections.sec6.singular,
        mode: "edit",
        data: data,
      };
      this.selectedComponent = ExportDataComponent;
    } else if (modalView == "listExport") {
      this.modalState = {
        title: this.translate.setup.importExport.sections.sec6.singular,
        mode: "edit",
        data: data,
      };
      this.selectedComponent = DownloadExportDataComponent;
    } else if (modalView == "viewCustomerFormat") {
      this.modalState = {
        title:
          this.translate?.customer.label.singular +
          " " +
          this.translate?.setup.modules.configuration.fields.format.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = CustomerFormatComponent;
    } else if (modalView == "viewAssetFormat") {
      this.modalState = {
        title:
          this.translate?.asset.label.singular +
          " " +
          this.translate?.setup.modules.configuration.fields.format.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = AssetFormatComponent;
    } else if (modalView == "viewTicketFormat") {
      this.modalState = {
        title:
          this.translate.setup.modules.configuration.sections.sec5.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = TicketFormatComponent;
    } else if (modalView == "viewSalesOrderFormat") {
      this.modalState = {
        title:
          this.translate?.salesOrder.label.singular +
          " " +
          this.translate?.setup.modules.configuration.fields.format.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = SalesOrderFormatComponent;
    } else if (modalView == "viewJobOrderFormat") {
      this.modalState = {
        title:
          this.translate?.jobOrder.label.singular +
          " " +
          this.translate?.setup.modules.configuration.fields.format.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = JobOrderFormatComponent;
    } else if (modalView == "viewPdfFormat") {
      this.modalState = {
        title:
          this.translate?.jobOrder.label.singular +
          " " +
          this.translate?.setup.modules.configuration.fields.format.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = TemplateFormatComponent;
    } else if (modalView == "checkAvailability") {
      this.modalState = {
        title: this.translate.contracts.sections.sec10.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = CheckAvailabilityComponent;
    } else if (modalView == "taskClone") {
      this.modalState = {
        title: this.translate.task.sections.sec30.singular,
        mode: "add",
        data: data,
      };
      this.selectedComponent = TaskCloneComponent;
    } else if (modalView == "uploadPhoto") {
      this.modalState = {
        title: this.translate.general.buttons.uploadPhoto.singular,
        data: data,
        type: "user",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = UploadPhotoComponent;
    } else if (modalView == "uploadTeamPhoto") {
      this.modalState = {
        title: this.translate.general.buttons.uploadPhoto.singular,
        data: data,
        type: "team",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = UploadPhotoComponent;
    } else if (modalView == "infoGuide") {
      this.modalState = {
        title: "Guide",
        data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = InfoGuideComponent;
    } else if (modalView == "hierarchyHelp") {
      this.modalState = {
        title: this.translate.setup.hierarchy.sections.sec4.singular,
        data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = InfoGuideComponent;
    } else if (modalView == "cloneAssign") {
      this.modalState = {
        title: this.translate.setup.users.access.sections.sec16.singular,
        data,
      };
      this.selectedComponent = CloneAccessComponent;
    } else if (modalView == "magnumDashboardTable") {
      this.modalState = {
        title: data.title,
        data,
      };
      this.selectedComponent = MagnumDashboardTableComponent;
    } else if (modalView === "acceptTask") {
      console.log(data);
      let mode = "accept";
      if (data.groupId) {
        mode = "acceptGroup";
      }
      this.modalState = {
        mode: mode,
        data: data,
        userId: this.auth.getUserId(),
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = AcceptDeclineTaskComponent;
    } else if (modalView === "declineTask") {
      let mode = "decline";
      if (data.groupId) {
        mode = "declineGroup";
      }
      this.modalState = {
        mode: mode,
        data: data,
        userId: this.auth.getUserId(),
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = AcceptDeclineTaskComponent;
    } else if (modalView === "addMember") {
      this.modalState = {
        mode: "add",
        data: data,
        title: this.translate.task.sections.sec31.singular,
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = AddMemberComponent;
    } else if (modalView === "requestAssistance") {
      this.modalState = {
        title: this.translate.task.fields.requestAssistance.singular,
        mode: "add",
        data: data,
      };
      this.selectedComponent = RequestAssistanceComponent;
      this.selectedConfig = this.configSM;
    } else if (modalView == "viewProjectFormat") {
      this.modalState = {
        title:
          this.translate?.project.label.singular +
          " " +
          this.translate?.setup.modules.configuration.fields.format.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = ProjectFormatComponent;
    } else if (modalView == "viewSiteFormat") {
      this.modalState = {
        title:
          this.translate?.site.label.singular +
          " " +
          this.translate?.setup.modules.configuration.fields.format.singular,
        mode: "add",
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = SiteFormatComponent;
    } else if (modalView == "taskJourney") {
      this.modalState = {
        title: this.translate.task.sections.sec27.singular,
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = TaskJourneyComponent;
    } else if (modalView == "joTimeJourney") {
      this.modalState = {
        title: "Job Journey",
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = JoTimeJourneyComponent;
    } else if (modalView == "hazardControl") {
      this.modalState = {
        title: this.translate.task.sections.sec32.singular,
        mode: "add",
        data: data,
      };
      // this.selectedConfig = this.configCustomLg;
      this.selectedComponent = HazardControlComponent;
    } else if (modalView == "exact-assign") {
      this.modalState = {
        title: this.translate.general.buttons.assign.singular,
        mode: "add",
        data: data,
      };

      this.selectedComponent = ExactAssignComponent;
    } else if (modalView == "taskTrigger") {
      this.modalState = {
        title: this.translate.setup.modules.templates.sections.sec17.singular,
        mode: "add",
        data: data,
        fromPage: "taskTrigger",
      };
      // this.selectedConfig = this.configCustomLg;
      this.selectedComponent = AddJoTaskTemplateComponent;
    } else if (modalView == "sendCalendlyLink") {
      this.modalState = {
        title: this.translate?.jobOrder.fields.sendCalendlyLink.singular,
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = CalendlyLinkComponent;
    } else if (modalView == "setUpEvents") {
      this.modalState = {
        title: this.translate.general.buttons.setUpEvents.singular,
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = SetUpEventsComponent;
    } else if (modalView == "updateTheme") {
      this.modalState = {
        title: this.translate.general.buttons.updateTheme.singular,
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = UpdateThemeComponent;
    } else if (modalView == "salesforceIntegrate") {
      this.modalState = {
        title:
          this.translate.setup.integrations.fields.salesforceIntegration
            .singular,
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = SalesforceIntegrationComponent;
    } else if (modalView == "DisconnectGoogleCalenderConfmationComponent") {
      this.modalState = {
        title: this.translate.setup.integrations.sections.sec9.singular,
        data: data,
        page: "Google",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = DisconnectConfmationComponent;
    } else if (modalView == "DisconnectMicrosoftCalenderConfmationComponent") {
      this.modalState = {
        title: this.translate.setup.integrations.sections.sec10.singular,
        data: data,
        page: "Microsoft",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = DisconnectConfmationComponent;
    } else if (modalView == "DisconnectCalendlyConfmationComponent") {
      this.modalState = {
        title: this.translate.setup.integrations.sections.sec11.singular,
        data: data,
        page: "Calendly",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = DisconnectConfmationComponent;

      //sendSurvey Link//
    } else if (modalView == "sendSurveyLink") {
      this.modalState = {
        title: this.translate?.jobOrder.fields.sendSurveyLink.singular,
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLg;
      this.selectedComponent = SurveyLinkComponent;
    } else if (modalView === "viewSurveyForm") {
      this.modalState = {
        title: this.translate?.jobOrder.sections.sec47.singular,
        data: data,
        mode: data.mode,
      };

      this.selectedComponent = ViewSurveyFormComponent;
    } else if (modalView == "uploadCalendlyLogo") {
      this.modalState = {
        title: this.translate?.setup.users.users.sections.sec23.singular,
        data: data,
        type: "CalendlyLogo",
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = UploadPhotoComponent;
    } else if (modalView == "uploadHeaderFooter") {
      this.modalState = {
        title: this.translate.general.buttons.uploadImage.singular,
        data: data,
      };
      this.selectedConfig = this.configSM;
      this.selectedComponent = AddImageEmailComponent;
    } else if (modalView == "previewEmail") {
      this.modalState = {
        title: this.translate?.setup.templates.email.sections.sec2.singular,
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = PreviewEmailComponent;
    } else if (modalView == "howApprovalWorksConsignment") {
      this.modalState = {
        title: this.translate?.setup.configuration.notifications.label.singular,
        data: data,
        parentType: "consignment",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = HowItWorksComponent;
    } else if (modalView == "howApprovalWorksRequisition") {
      this.modalState = {
        title: this.translate?.setup.configuration.notifications.label.singular,
        data: data,
        parentType: "requisition",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = HowItWorksComponent;
    } else if (modalView === "addNotification") {
      this.modalState = {
        title: this.translate?.setup.configuration.notifications.label.singular,
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = AddExistingNotificationComponent;
    } else if (modalView === "howToCondition") {
      this.modalState = {
        // title:  this.translate?.setup.configuration.notifications.label.singular,
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = HowToConditionComponent;
    } else if (modalView === "howToEmail") {
      this.modalState = {
        // title:  this.translate?.setup.configuration.notifications.label.singular,
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = HowToEmailComponent;
    } else if (modalView === "smartSuggestions") {
      this.modalState = {
        // title:  this.translate?.setup.configuration.notifications.label.singular,
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = SmartSuggestionsComponent;
    } else if (modalView == "addProductMultiple") {
      this.modalState = {
        title: this.translate.checklist.sections.sec13.singular,
        mode: "create",
        data: data,
      };
      // this.selectedConfig = this.configMdCenter;
      this.selectedComponent = CommonProductComponent;
    } else if (modalView === "addViaSerialNumberSku") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AddViaSerialNumberSkuComponent;
    } else if (modalView === "updateChildAsset") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = UpdateChildAssetComponent;
    } else if (modalView == "editRequisitionNote") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        type: "requisition",
        transferType: "header",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = EditRequisitionNotesComponent;
    } else if (modalView == "editRequisitionBody") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        type: "requisition",
        transferType: "body",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = EditRequisitionNotesComponent;
    } else if (modalView == "editConsignmentBody") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        type: "consignment",
        transferType: "body",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = EditRequisitionNotesComponent;
    } else if (modalView == "editConsignmentNote") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        transferType: "header",
        type: "consignment",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = EditRequisitionNotesComponent;
    } else if (modalView == "requestRequisitionSummary") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        type: "requisition",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = GlobalRequestSummaryComponent;
    } else if (modalView == "requestConsignmentSummary") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        type: "Consignment",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = GlobalRequestSummaryComponent;
    } else if (modalView == "approvalConsignmentConfiguration") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        type: "consignment",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ApprovalConfigurationComponent;
    } else if (modalView == "approvalRequisitionConfiguration") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        type: "requisition",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ApprovalConfigurationComponent;
    } else if (modalView == "userBins") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        mode: "add",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = AddEditUserBinsComponent;
    } else if (modalView == "userBinsEdit") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        mode: "edit",
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = AddEditUserBinsComponent;
    } else if (modalView == "assetBulkExportQr") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        mode: "add",
      };
      this.selectedConfig = this.configCustomLgCenter;
      this.selectedComponent = BulkExportQrComponent;
    } else if (modalView == "upgradeToPlan") {
      this.modalState = {
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configCenterOnly;
      this.selectedComponent = UpgradeToPlanComponent;
    } else if (modalView === "createAssetJobOrder") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = CreateAssetJoComponent;
    } else if (modalView === "requestDeleteOrg") {
      this.modalState = {
        mode: "add",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = RequestOrgDeleteComponent;
    } else if (modalView === "learnMore") {
      this.modalState = {
        mode: "add",
        data: data2,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = LearnMoreModalComponent;
    } else if (modalView === "importAssetsModal") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ImportAssetsComponent;
    } else if (modalView == "addEditFolderTree") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = AddEditFolderTreeComponent;
    } else if (modalView == "addEditReport") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = AddEditReportComponent;
    } else if (modalView == "exportReport") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ReportExportComponent;
    } else if (modalView == "scheduleExportReport") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ReportScheduleExportComponent;
    } else if (modalView == "duplicateReport") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ReportDuplicateComponent;
    } else if (modalView == "moveReport") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ReportMoveComponent;
    } else if (modalView === "addComponents") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLgCenter;
      this.selectedComponent = AddEditComponentComponent;
    } else if (modalView == "discardReport") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = ReportDeleteComponent;
    } else if (modalView == "multipleScheduleReport") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ReportMultipleScheduleComponent;
    } else if (modalView == "changeOwnership") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = OwnershipConfirmationPopupComponent;
    } else if (modalView === "previewSelection") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = PreviewSelectedPlanComponent;
    } else if (modalView === "assignTo") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AssignToComponent;
    } else if (modalView === "clonePlan") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ClonePlanComponent;
    } else if (modalView === "adjustDatePlan") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AdjustDatePlanComponent;
    } else if (modalView === "chooseJobType") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = ChooseJobTypeComponent;
    } else if (modalView === "chooseJobTemplate") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ChooseJobTemplateComponent;
    } else if (modalView === "updateAssignee") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = UpdateAssigneeComponent;
    } else if (modalView === "addProcedure") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AddProcedureComponent;
    } else if (modalView === "updateLocation") {
      this.modalState = {
        title: "Select Location",
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = UpdateLocationComponent;
    } else if (modalView === "updateContact") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = UpdateContactComponent;
    } else if (modalView === "cloneType") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMLongCenter;
      this.selectedComponent = CloneTypeComponent;
    } else if (modalView === "addStatus") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AddStatusComponent;
    } else if (modalView === "addAssetStatus") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AddAssetStatusComponent;
    } else if (modalView === "configureCert") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdSkimCenter;
      this.selectedComponent = ConfigureCertificateComponent;
    } else if (modalView === "configureInspect") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = ConfigureInspectionComponent;
    } else if (modalView === "markCompleteCert") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = MarkCompleteCertComponent;
    } else if (modalView === "reorderType") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = ReorderTypesComponent;
    } else if (modalView === "utilizeFromBin") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = UtilizeFromBinComponent;
    } else if (modalView === "assignJoOwner") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = AssignJoOwnerComponent;
    } else if (modalView === "emailPdfJo") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = JoStandaloneEmailPdfComponent;
    } else if (modalView === "liveFromPreviewJo") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCenterOnly;
      this.selectedComponent = LiveFormPreviewComponent;
    } else if (modalView === "oauthCredentials") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = OauthCredentialsComponent;
    } else if (modalView == "productBulkExportQr") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
        mode: "add",
      };
      this.selectedConfig = this.configCustomLgCenter;
      this.selectedComponent = ProductBulkExportQrComponent;
    } else if (modalView == "viewMappedFieldsInApp") {
      this.modalState = {
        data: data,
        mode: "view",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = MappedFieldsComponent;
    } else if (modalView == "viewMappedFieldsInAppXero") {
      this.modalState = {
        data: data,
        mode: "view",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = XeroMappedFieldsComponent;
    } else if (modalView === "filterOptions") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = FilterOptionsComponent;
    } else if (modalView === "groupByOptions") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = GroupByOptionsComponent;
    } else if (modalView === "settingsColorCode") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = SettingsColorCodeComponent;
    } else if (modalView === "reScheduleJobOrder") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = ReScheduleComponent;
    } else if (modalView === "printJobSheet") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = PrintJobSheetComponent;
    } else if (modalView === "sendEmailPdfJo") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = SendEmailPdfComponent;
    } else if (modalView === "ownerAssign") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = OwnerAssignComponent;
    } else if (modalView == "activatePortal") {
      this.modalState = {
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = ActivatePortalComponent;
    } else if (modalView == "availableStatusesInPortal") {
      this.modalState = {
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configMdCenter;
      this.selectedComponent = AvailableStatusesComponent;
    } else if (modalView == "documentsCta") {
      this.modalState = {
        data: data,
        mode: "add",
        type: data.type,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = DocumentsCtaComponent;
    } else if (modalView == "newRecipientEmail") {
      this.modalState = {
        data: data, // This contains your emailName and mode
        title: "Add New Recipient",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = NewRecipientComponent;
    } else if (modalView == "viewPdfDocument") {
      this.modalState = {
        data: data, // This contains your emailName and mode
        title: "Add New Recipient",
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = PdfViewerComponent;
    } else if (modalView === "transferPdf") {
      this.modalState = {
        data: data, // This contains your emailName and mode
        title: "Transfer PDF",
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = TransferPdfComponent;
    } else if (modalView == "missingConfig") {
      this.modalState = {
        data: data,
        mode: "add",
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = MissingConfigurationComponent;
    } else if (modalView === "planTypeOptions") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdSkimCenter;
      this.selectedComponent = PlanTypeOptionsComponent;
    }  
    else if (modalView == "viewMaintenanceJobs") {
      this.modalState = {
        data: data,
        title: "Maintenance Jobs",
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = MaintenanceJobListComponent;
    } else if (modalView == "viewComplianceCertInspec") {
      this.modalState = {
        data: data,
        title:
          data?.recordType === "INSPECTION" ? "Inspections" : "Certifications",
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = ComplianceCertInspecListComponent;
    } else if (modalView == "viewAssetOpenJobs") {
      this.modalState = {
        data: data,
        title:
          "Open" +
          " " +
          this.translate.jobOrder.label.plural +
          " " +
          "by " +
          this.translate?.jobOrder.fields.status.singular,
      };
      this.selectedConfig = this.configCustomXl;
      this.selectedComponent = AssetOpenJobComponent;
    } else if (modalView === "updateAssetStatusComponent") {
      this.modalState = {
        data: data,
        userId: this.auth.getUserId(),
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = UpdateComponentConfirmComponent;
    } else if (modalView === "manageSkills") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdSkimCenter;
      this.selectedComponent = UserManageSkillsComponent;
    } else if (modalView === "manageWorkingHours") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdSkimCenter;
      this.selectedComponent = ManageWorkingHoursComponent;
    } else if (modalView === "manageSetupAccess") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdSkimCenter;
      this.selectedComponent = ManageSetupAccessComponent;
    } else if (modalView === "createBlockAreaLevel") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = CreateBlockAreaLvlComponent;
    } else if (modalView === "createBlockTask") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = CreateBlockTaskComponent;
    } else if (modalView === "createContractBlock") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = CreateContractInBlockComponent;
    } else if (modalView === "autoAssignMonth") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = AutoAssignMonthComponent;
    } else if (modalView === "generateJobPlanner") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMLongCenter;
      this.selectedComponent = GenerateJobPlannerComponent;
    } else if (modalView === "clearMonth") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = ClearMonthComponent;
    } else if (modalView === "bulkReassignUser") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = BulkReassignUserComponent;
    } else if (modalView === "selectExistingContractBlock") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = SelectExistingContractInBlockComponent;
    } else if (modalView === "manageUserGroup") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = ManageUserGroupComponent;
    } else if (modalView === "manageIntegrations") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdSkimV2Center;
      this.selectedComponent = ManageIntegrationsComponent;
     } else if (modalView === "assignShift") {
      const assignmentId = data?.assignmentId ?? data?.id;
      const isEdit =
        assignmentId != null &&
        assignmentId !== "" &&
        !String(assignmentId).startsWith("row-");
      this.modalState = {
        mode: isEdit ? "edit" : "add",
        data: data,
        viewMode: data?.viewMode,
      };
      this.selectedConfig = this.configMdSkimCenter;
      this.selectedComponent = AssignShiftsComponent;
    } else if (modalView === "importBulkShift") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configCustomLgNonScroll;
      this.selectedComponent = ImportBulkShiftsComponent;
    } else if (modalView === "suggestedUsersPreview") {
      this.modalState = {
        mode: "add",
        data: data,
      };
      this.selectedConfig = this.configMdSkimV2Center;
      this.selectedComponent = PreviewSuggestedUsersComponent;
  
    }  
    else if (modalView === "updateAssetStatusComponent") {
      this.modalState = {
        data: data, // This contains your emailName and mode
        title: "Link Asset to Customer Site Project"
      };
      this.selectedConfig = this.configSMCenter;
      this.selectedComponent = UpdateComponentConfirmComponent;
    } else if (modalView == "createMilestoneProject") {
      this.modalState = {
        mode: "add",
        data: data
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = CreateMilestonesComponent;
    } else if (modalView == "editMilestoneProject") {
      this.modalState = {
        mode: "edit",
        data: data
      };
      this.selectedConfig = this.configSMSkimCenter;
      this.selectedComponent = CreateMilestonesComponent;
    }
      else {
      return;
    }

    this.selectedConfig.initialState = this.modalState;
    this.modalRef = this.modalService.show(
      this.selectedComponent,
      this.selectedConfig
    );

    this.allModalRefs.push(this.modalRef);

    return this.modalRef;
  }
}
